export const categories = [
  {
    slug: 'mingxing-fanche',
    name: '明星翻车',
    description: '追踪娱乐圈明星翻车现场，最新塌房爆料不间断更新',
    icon: 'ri-user-star-line',
  },
  {
    slug: 'wanghong-tafang',
    name: '网红塌房',
    description: '网红圈大瓜第一手资料，人设崩塌全记录',
    icon: 'ri-live-line',
  },
  {
    slug: 'qiye-neimu',
    name: '企业内幕',
    description: '深度挖掘企业黑料，曝光商业圈不为人知的真相',
    icon: 'ri-building-line',
  },
  {
    slug: 'shishi-baoliao',
    name: '实时爆料',
    description: '24小时不间断更新最新吃瓜爆料，绝不错过每一个大瓜',
    icon: 'ri-flashlight-line',
  },
  {
    slug: 'heiliao-baoguang',
    name: '黑料曝光',
    description: '独家黑料深度曝光，带你了解事件背后的真相',
    icon: 'ri-eye-line',
  },
];

export type Category = typeof categories[0];